import React, { useEffect } from "react";
import { PageLayout } from "../../app/PageLayout";
import { Button, Card } from "../../components/ui";
import { MessageKey, t } from "../../i18n";
import { StepKey } from "./appeal";
import { ConfirmStep } from "./steps/ConfirmStep";
import { DeniedItemsStep } from "./steps/DeniedItemsStep";
import { FinishedStep } from "./steps/FinishedStep";
import { GeneratedAppealStep } from "./steps/GeneratedAppealStep";
import { GroundsStep } from "./steps/GroundsStep";
import { SelectOrderStep } from "./steps/SelectOrderStep";
import { TechnicalReviewStep } from "./steps/TechnicalReviewStep";
import { StepsProgress } from "./StepsProgress";
import { AppealWizard, useAppealWizard } from "./useAppealWizard";

const STEPS: Record<StepKey, React.FC<{ w: AppealWizard }>> = {
  order: SelectOrderStep,
  items: DeniedItemsStep,
  grounds: GroundsStep,
  confirm: ConfirmStep,
  generated: GeneratedAppealStep,
  review: TechnicalReviewStep,
  done: FinishedStep,
};

const CTA: Partial<Record<StepKey, MessageKey>> = { confirm: "appeals.cta.generate", review: "appeals.cta.finish" };

/** Recursos: assistente de 7 passos para contestar a negativa da operadora. */
export const AppealsPage: React.FC = () => {
  const w = useAppealWizard();
  const Step = STEPS[w.step];
  const done = w.step === "done";
  const canGoBack = w.stepIndex > 0 && !done && !w.generating;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [w.stepIndex]);

  return (
    <PageLayout
      title={t("appeals.title")}
      onBack={canGoBack ? w.goBack : undefined}
      ctaHint={w.blocked ? t(w.blocked) : undefined}
      cta={
        !done && (
          <>
            {canGoBack && (
              <Button variant="outline" size="lg" onClick={w.goBack}>
                {t("common.back")}
              </Button>
            )}
            <Button variant="primary" size="lg" disabled={!!w.blocked} loading={w.generating} onClick={w.goNext}>
              {t(w.generating ? "appeals.cta.generating" : CTA[w.step] ?? "appeals.cta.continue")}
            </Button>
          </>
        )
      }
    >
      <div className="animate-rise">
        <StepsProgress index={w.stepIndex} />
      </div>
      <Card key={w.step} className="animate-rise">
        <Step w={w} />
      </Card>
    </PageLayout>
  );
};
